import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import { SCRAPE_TYPES, SCRAPE_STATUS } from 'config'
import type { ScrapeHistoryState, ScrapeHistoryItem } from '../types'
import { getScrapeHistory } from './helpers'

const noScrapeHistoryConfig = {
  history: [],
  isInitalized: false,
  isLoading: true,
  hasError: false,
  page: 1,
  limit: 200,
  types: Object.keys(SCRAPE_TYPES).map((key) => SCRAPE_TYPES[key]),
  statuses: Object.keys(SCRAPE_STATUS).map((key) => SCRAPE_STATUS[key]),
}

interface SetHistoryPayload {
  history: ScrapeHistoryItem[]
}

interface FetchHistoryPayload {
  page: number
  limit: number
  types: SCRAPE_TYPES[]
  statuses: SCRAPE_STATUS[]
}

const initialState: ScrapeHistoryState = { ...noScrapeHistoryConfig }

export const scrapeHistorySlice = createSlice({
  name: 'ScrapeHistory',
  initialState,
  reducers: {
    fetchHistory: (state, action: PayloadAction<FetchHistoryPayload>) => {
      state.isLoading = true
      state.hasError = false
      state.page = action.payload.page
      state.limit = action.payload.limit
      state.types = action.payload.types
      state.statuses = action.payload.statuses
    },
    setHistory: (state, action: PayloadAction<SetHistoryPayload>) => {
      state.history = action.payload.history
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchHistoryFailed: (state) => {
      state.history = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchScrapeHistory = (page, limit, types, statuses) => async (dispatch) => {
  try {
    dispatch(fetchHistory({ page, limit, types, statuses }))
    const history = await getScrapeHistory(page, limit, types, statuses)
    dispatch(
      setHistory({
        history,
      }),
    )
  } catch (error) {
    message.error('Error gettings scrape history')
    dispatch(fetchHistoryFailed())
  }
}

// Actions
export const { fetchHistory, setHistory, fetchHistoryFailed } = scrapeHistorySlice.actions

export default scrapeHistorySlice.reducer
